import { render } from "./AttributeItem.vue?vue&type=template&id=26fa40ac"
import script from "./AttributeItem.vue?vue&type=script&lang=js"
export * from "./AttributeItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__